<template>
  <div class="welcome-aboard-component">
    <div class="container h-100">
      <div class="row h-100 align-items-center">
        <div class="col-12">
          <div class="text-start d-flex flex-column">
            <div class="row">
              <div class="col-6 offset-3">
                <div v-if="session.profile">
                  <h1 v-if="session">{{ adjustedHeading }}</h1>
                  <p>{{ description }}</p>
                  <button @click="$router.push('origo-user-guide')" class="button button--steelBlue">{{ buttonText }} <i
                    class="icon-arrow-right"></i></button>
                </div>
                <div v-else>
                  <div class="text-center my-5">
                    <loading-icon/>
                    <h3 class="mt-2">Loading policies</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-text v-if="footerText" :footerText="footerText"/>
  </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';
import FooterText from "./footer/footer-text";
import LoadingIcon from "@/components/loading-icon.vue";

export default {

  components: {LoadingIcon, FooterText},

  props: [
    'session',
    'adminPortalData',
    'adminPortalPrimaryProduct'
  ],

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.get();
    })
  },

  async beforeMount(to, from, next) {
    EventBus.$emit('fetchData', [
      'driverprofile',
      'profile'
    ]);
  },

  computed: {
    heading() {
      return this.adminPortalPrimaryProduct.welcome_onboarding_heading;
    },
    description() {
      return this.adminPortalPrimaryProduct.welcome_onboarding_description;
    },
    buttonText() {
      return this.adminPortalPrimaryProduct.welcome_onboarding_button_text;
    },
    footerText() {
      return this.adminPortalData.content?.products?.ecoamaps
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description_required
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_description_required_on_welcome_onboarding
        ? this.adminPortalData.content.products.ecoamaps[0].fca_requirement_and_content_fca_description
        : false;
    },
    adjustedHeading() {
      return this.heading.replace('{USER_FIRSTNAME}', this.session.profile.firstName);
    }
  },

  methods: {
    get() {
      EventBus.$emit('loadingTitle', 'Loading Origo');
      EventBus.$emit('loading', true);

      this.$http.get('/api/welcome-aboard')
        .then(response => {
          EventBus.$emit('loading', false);
          this.$parent.session = response.data.session;
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.message
          });
          this.error = err.message.toString();
          this.$router.push({name: response.redirect});
        });
    }
  }
}
</script>
